import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../core/services/event.service';
import { AuthService } from '../../core/services/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

interface Member {
  workplace: string;
  position: string;
  name: string;
  id: string;
}

interface UserProfile {
  profilePicture?: { url: string } | null;
  regCode: string;
  position: string;
  description: string;
  description1: [];
  name: string;
  grade: string;
  firstLogin: string;
  dashboardSettings: {
    recentArticles: boolean;
    recentBooks: boolean;
    recentPosts: boolean;
    recentNews: boolean;
    myProfile: boolean;
    calendar: boolean;
    invitedEvents: boolean;
    upcomingEvents: boolean;
  } | null;
  _id: string;
}

@Component({
  selector: 'app-users',
  templateUrl: './single-event.component.html',
  styleUrls: ['./single-event.component.scss'],
})
export class SingleEventsComponent implements OnInit {
  showMore: any;
  showMoreAcc: any;
  showMoreRej: any;
  event = {
    id: '',
    name: 'title',
    thumbnail: { url: 'url' },
    resources1: [
      {
        content: '',
      },
    ],
    description: 'description',
    description1: [],
    agenda1: [
      {
        content: '',
        children: [
          {
            text: '',
          },
        ],
      },
    ],
    agendaPDFs: 
      {
        url: 'url',
      },
    startTime: 'datetime',
    endTime: 'end Time',
    venue: 'venue',
    willAttend: [
      {
        id: '',
        name: 'name',
        position: 'position',
        workplace: 'workplace',
        profilePicture: { url: '' },
      },
    ],
    willNotAttend: [
      {
        id: '',
        name: 'name',
        position: 'position',
        workplace: 'workplace',
        profilePicture: { url: '' },
      },
    ],
    willNotAttendReasons: [
      {
        member: '',
        reason: '',
      },
    ],
    participantListPDF: {
      url: 'url',
      filename: '',
      alt: '',
    },
    media: [{ url: 'url', mimeType: 'type', filename: 'fileName' , alt: 'alt' }],
    logisticReports:[{ url: 'url', mimeType: 'type', filename: 'fileName' , alt: 'alt' }],
    link: '',
  };

  loggedUser: UserProfile = {
    profilePicture: null,
    regCode: '',
    position: '',
    grade: '',
    description: '',
    description1: [],
    name: '',
    dashboardSettings: {
      recentArticles: true,
      recentBooks: true,
      recentPosts: true,
      recentNews: true,
      myProfile: true,
      calendar: true,
      invitedEvents: true,
      upcomingEvents: true,
    },
    firstLogin: '',
    _id: '',
  };
  isVisibleForm = false;
  isAttendanceForm = false;
  isReasonModalVisible = false;
  attendanceForm!: FormGroup;
  reasonForm!: FormGroup;
  selectedEvent: any = null;
  selectedEventID = ''; 


  filesData = [
    { type: 'pdf', url: 'example.pdf' },
    { type: 'image', url: 'example.jpg' },
  ];
  user = { _id: '' };
  breadcrumbs: any[] = [];

  constructor(
    private authService: AuthService,
    private datePipe: DatePipe,
    private eventService: EventService,
    private activatedRoute: ActivatedRoute,
    private message: NzMessageService,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.eventService.getEventsById(id).then((resp) => {
        this.user = this.authService.getLoggedInUser();
        this.event = resp;
        this.initCrumbs();
      });
    }
    this.loggedUser = this.authService.getLoggedInUser();
    this.initAttendanceForm();
    this.initReasonForm();
    console.log('Agenda data:', {
      agenda1: this.event.agenda1,
      type: typeof this.event.agenda1,
      agendaPDF: this.event.agendaPDFs
    });
  }

  initReasonForm(): void {
    this.reasonForm = this.formBuilder.group({
      reason: ['', Validators.required],
    });
  }

  hasAgendaContent(): boolean {
    return (
      this.event.agenda1?.[0]?.children?.[0]?.text?.trim()?.length > 0 || 
      !!this.event.agendaPDFs?.url
    );
  }


  formatDate(startDate: string, endDate: string): string {
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return 'Invalid Date Range';
    }
  
    // Format both date and time together for start and end
    const dateTimeOptions: Intl.DateTimeFormatOptions = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };
  
    const startFormatted = new Intl.DateTimeFormat('en-US', dateTimeOptions)
      .format(start)
      .replace(',', '')
      .replace(' at ', ' - ');
    
    const endFormatted = new Intl.DateTimeFormat('en-US', dateTimeOptions)
      .format(end)
      .replace(',', '')
      .replace(' at ', ' - ');
  
    return `${startFormatted} | ${endFormatted}`;
  }

  initCrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'Events',
        route: '/admin/events',
      },
      {
        title: this.event.name,
      },
    ];
  }

  showLink(): boolean {
    return !!(this.event.link && this.event.link.trim() !== '');
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  onImageProfile(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/avatar_image.jpg';
  }

  isVisible(data: any, flag: any): boolean {
    // All events are now open, so always show attendance buttons
    return true;
  }

  hasRSVPResponse(): boolean {
    const willAttend = this.event.willAttend?.some(
      (item: { id: string }) => item.id === this.user._id
    );
    const willNotAttend = this.event.willNotAttend?.some(
      (item: { id: string }) => item.id === this.user._id
    );
    return willAttend || willNotAttend || false;
  }

  getRSVPResponse(): string {
    if (this.event.willAttend?.some((item: { id: string }) => item.id === this.user._id)) {
      return 'willAttend';
    }
    if (this.event.willNotAttend?.some((item: { id: string }) => item.id === this.user._id)) {
      return 'willNotAttend';
    }
    return 'none';
  }

  addParticipant(reply: any): void {
    let payload: {
      willAttend?: string[];
      willNotAttend?: string[];
    } = {}; // Initialize as an object
    let willAttendIds: string[] = [];
    let willNotAttendIds: string[] = [];

    if (this.user._id) {
      if (reply === 'WillAttend') {
        // Handle RSVP: I will attend
        if (this.event.willAttend) {
          willAttendIds = this.event.willAttend.map(
            (member: Member) => member.id,
          );
        }
        // Remove from willNotAttend if present
        if (this.event.willNotAttend) {
          willNotAttendIds = this.event.willNotAttend
            .filter((item: { id: string }) => item.id !== this.user._id)
            .map((item: { id: string }) => item.id);
        }
        // Add to willAttend if not already present
        if (!willAttendIds.includes(this.user._id)) {
          willAttendIds.push(this.user._id);
        }
        payload = { willAttend: willAttendIds, willNotAttend: willNotAttendIds };

        this.eventService.updateEvent(this.event.id, payload).then(() => {
          this.message.create(
            'success',
            `Your response "I will attend" has been recorded!`,
          );
          this.ngOnInit();
        });
      } else if (reply === 'WillNotAttend') {
        // Show reason modal first
        this.isReasonModalVisible = true;
      }
    }
  }

  isExpired(date: any): boolean {
    const inputDate = new Date(date);
    // Get the current date
    const currentDate = new Date();
    // Compare the two dates
    return inputDate.getTime() >= currentDate.getTime();
  }

  serializeToHTML(children: any[]): string {
    return children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let text = `<span>${this.escapeHTML(node.text)}</span>`;

          if (node.bold) {
            text = `<strong>${text}</strong>`;
          }

          if (node.code) {
            text = `<code>${text}</code>`;
          }

          if (node.italic) {
            text = `<em>${text}</em>`;
          }

          if (node.underline) {
            text = `<u>${text}</u>`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<h1>${this.serializeToHTML(node.children)}</h1>`;
          case 'h2':
            return `<h2>${this.serializeToHTML(node.children)}</h2>`;
          case 'h3':
            return `<h3>${this.serializeToHTML(node.children)}</h3>`;
          case 'h4':
            return `<h4>${this.serializeToHTML(node.children)}</h4>`;
          case 'h5':
            return `<h5>${this.serializeToHTML(node.children)}</h5>`;
          case 'h6':
            return `<h6>${this.serializeToHTML(node.children)}</h6>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<a class="richLink" href="${this.escapeHTML(node.url)}">${this.serializeToHTML(
              node.children,
            )}</a>`;

          default:
            return `<p class="w-full  font-[400]">${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');
  }

  private escapeHTML(text: string): string {
    return text;
  }

  handleCancel(): void {
    this.isVisibleForm = false;
    this.isAttendanceForm = false;
    this.isReasonModalVisible = false;
    this.reasonForm.reset();
    // this.event = null;
  }

  handleReasonSubmit(): void {
    if (this.reasonForm.invalid) {
      for (const i in this.reasonForm.controls) {
        if (this.reasonForm.controls.hasOwnProperty(i)) {
          this.reasonForm.controls[i].markAsDirty();
          this.reasonForm.controls[i].updateValueAndValidity();
        }
      }
      return;
    }

    const reason = this.reasonForm.value.reason;
    let payload: {
      willAttend?: string[];
      willNotAttend?: string[];
      willNotAttendReasons?: any[];
    } = {};
    let willAttendIds: string[] = [];
    let willNotAttendIds: string[] = [];
    let reasons: any[] = [];

    // Get existing reasons
    if (this.event.willNotAttendReasons) {
      reasons = [...this.event.willNotAttendReasons];
    }

    // Remove existing reason for this user if any
    reasons = reasons.filter((r: any) => {
      const memberId = typeof r.member === 'string' ? r.member : r.member?.id;
      return memberId !== this.user._id;
    });

    // Add new reason
    reasons.push({
      member: this.user._id,
      reason: reason,
    });

    // Handle willNotAttend list
    if (this.event.willNotAttend) {
      willNotAttendIds = this.event.willNotAttend.map(
        (member: Member) => member.id,
      );
    }
    // Remove from willAttend if present
    if (this.event.willAttend) {
      willAttendIds = this.event.willAttend
        .filter((item: { id: string }) => item.id !== this.user._id)
        .map((item: { id: string }) => item.id);
    }
    // Add to willNotAttend if not already present
    if (!willNotAttendIds.includes(this.user._id)) {
      willNotAttendIds.push(this.user._id);
    }

    payload = {
      willAttend: willAttendIds,
      willNotAttend: willNotAttendIds,
      willNotAttendReasons: reasons,
    };

    this.eventService.updateEvent(this.event.id, payload).then(() => {
      this.message.create(
        'success',
        `Your response "I will not attend" with reason has been recorded!`,
      );
      this.isReasonModalVisible = false;
      this.reasonForm.reset();
      this.ngOnInit();
    });
  }

  // Attendence Form
  attendance: {
    name: string;
    designation: string;
    station: string;
    adultCount: string;
    childrenCount: string;
    childrenAge: string;
    roomType: string;
    datesOfStay: string;
  } = {
    name: '',
    designation: '',
    station: '',
    adultCount: '',
    childrenCount: '',
    childrenAge: '',
    roomType: '',
    datesOfStay: '',
  };

  initAttendanceForm(): void {
    this.attendanceForm = this.formBuilder.group({
      name: [this.attendance?.name || ''],
      designation: [this.attendance?.designation || '', Validators.required],
      station: [this.attendance?.station || '', Validators.required],
      adultCount: [
        this.attendance?.adultCount || '',
        [Validators.required, Validators.pattern('^[0-9]*$')],
      ],
      childrenCount: [
        this.attendance?.childrenCount || '',
        [Validators.required, Validators.pattern('^[0-9]*$')],
      ],
      childrenAge: [this.attendance?.childrenAge || ''],
      roomType: [this.attendance?.roomType || '', Validators.required],
      datesOfStay: [this.attendance?.datesOfStay || '', Validators.required],
    });
  }

  getFormControl(controlName: string) {
    return this.attendanceForm.get(controlName);
  }

  showModalAttendence(event: any): void {
    this.isVisibleForm = true;
    this.isAttendanceForm = true;
    this.selectedEventID = event.id;
    this.selectedEvent = event;
  }

  handleAttendanceFormSubmit(): void {
    if (this.attendanceForm.invalid) {
      for (const i in this.attendanceForm.controls) {
        if (this.attendanceForm.controls.hasOwnProperty(i)) {
          this.attendanceForm.controls[i].markAsDirty();
          this.attendanceForm.controls[i].updateValueAndValidity();
        }
      }
      return;
    }

    const formData = this.attendanceForm.value;
    const newAttendee = {
      name: this.loggedUser.name,
      designation: formData.designation,
      station: formData.station,
      adultCount: formData.adultCount,
      childrenCount: formData.childrenCount,
      childrenAge: formData.childrenAge,
      roomType: formData.roomType,
      datesOfStay: formData.datesOfStay,
    };

    this.eventService
      .getEventsById(this.selectedEventID)
      .then((event) => {
        const currentAttendees = event.attendees || [];
        const updatedAttendees = [...currentAttendees, newAttendee];

        this.eventService
          .updateEvent(this.selectedEventID, { attendees: updatedAttendees })
          .then(() => {
            this.addParticipant('Add');
            this.message.create(
              'success',
              'Registration Status Updated Successfully',
            );
          })
          .catch(() => {
            this.message.create('error', 'Failed to Update Event Registration');
          });

        this.isVisibleForm = false;
        this.isAttendanceForm = false;
      })
      .catch(() => {
        this.message.create('error', 'Failed to Fetch Current Attendees');
      });
  }

  // Helper method to check if reason member matches
  reasonMatchesMember(reason: any, memberId: string): boolean {
    if (!reason || !reason.member) return false;
    const reasonMemberId = typeof reason.member === 'string' ? reason.member : reason.member?.id;
    return reasonMemberId === memberId;
  }

  // Helper method to get reason for a member
  getReasonForMember(memberId: string): string {
    if (!this.event.willNotAttendReasons) return '';
    const reason = this.event.willNotAttendReasons.find((r: any) => {
      const reasonMemberId = typeof r.member === 'string' ? r.member : r.member?.id;
      return reasonMemberId === memberId;
    });
    return reason ? reason.reason : '';
  }

  // attendence form ends
}
